import { PostAlertsRequest } from '@api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { postAlerts } from '@terminal/services/alerts/event-alerts-service';
import { QUERY_KEY_EVENT_ALERTS } from './event-alerts-query-keys';
import { getEventAlertsInfiniteQueryOptions } from './usePostAlertsV2';

export const usePostAlerts = (body: PostAlertsRequest, enabled = true) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_EVENT_ALERTS, body],
    queryFn: ({ pageParam }) =>
      postAlerts({ ...body, next: pageParam ?? undefined }),
    enabled,
    ...getEventAlertsInfiniteQueryOptions(body.read === false),
  });
